/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('sideNotes', function() {
        return {
            scope: {},
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/sidenotes/sidenotes.view.html',
            controller: ["$scope", "NotesService", function($scope, NotesService) {
                var scope = $scope;

                scope.items = NotesService.getNotes();
                _.map(scope.items, function(el, i) {
                    el.index = i;
                });

                NotesService.subscribe.onNotesChange(function() {
                    scope.items = NotesService.getNotes();

                    _.map(scope.items, function(el, i) {
                        el.index = i;
                    });
                });

                scope.top = 0;

                NotesService.subscribe.onNotesWrapperOffsetChange(function(params) {
                    scope.top = params.newY + 20;
                });
            }]
        };
    });